export type FeedbackTabSlug = 'reviews' | 'questions';

function getSingleQueryValue(value: unknown): string | null {
  if (typeof value === 'string') return value;
  if (Array.isArray(value) && typeof value[0] === 'string') return value[0];

  return null;
}

export function isFeedbackTabSlug(value: unknown): boolean {
  return getSingleQueryValue(value) === 'reviews' || getSingleQueryValue(value) === 'questions';
}

export function getFeedbackTabFromHash(hash: string): FeedbackTabSlug | null {
  const fragment = hash.replace(/^#/, '').toLowerCase();

  if (fragment === 'reviews' || fragment.startsWith('review-')) return 'reviews';
  if (fragment === 'questions' || fragment.startsWith('question-') || fragment.startsWith('reply-')) {
    return 'questions';
  }

  return null;
}

export function resolveFeedbackTab(hash: string, legacyTab?: unknown): FeedbackTabSlug {
  const hashTab = getFeedbackTabFromHash(hash);
  if (hashTab) return hashTab;

  const tab = getSingleQueryValue(legacyTab);
  return tab === 'questions' ? 'questions' : 'reviews';
}

export function getReplyQuestionIdFromHash(hash: string): number | null {
  const match = hash.match(/^#question-(\d+)-reply-\d+$/i);
  if (!match) return null;

  const questionId = Number(match[1]);
  return Number.isSafeInteger(questionId) && questionId > 0 ? questionId : null;
}

export function removeLegacyFeedbackTab<T extends Record<string, unknown>>(query: T): Omit<T, 'tab'> {
  const { tab: _tab, ...rest } = query;

  return rest;
}

export function getNormalizedLegacyFeedbackHash(hash: string, legacyTab: unknown): string | null {
  if (!isFeedbackTabSlug(legacyTab)) return null;
  if (hash && hash !== '#feedback') return hash;

  return `#${getSingleQueryValue(legacyTab)}`;
}

export function setUrlHash(url: string, hash: string): string {
  return `${url.split('#', 1)[0]}#${hash.replace(/^#/, '')}`;
}
